import {
  importNativeOriginStorage,
  needsNativeOriginStorageMigration,
  OriginMigrationOutcome,
} from './helpers/nativeOriginStorageMigration';

interface IBootstrapOptions {
  initializeStore: () => void;
  startApp: (cordovaApp: boolean) => void;
  onDeviceReady: () => void;
  onMigrationChecked: (outcome: OriginMigrationOutcome) => void;
}

export function bootstrapApp(options: IBootstrapOptions): void {
  const needsImport = needsNativeOriginStorageMigration();
  if (!needsImport) {
    // Includes web, existing localhost state, and completed checks with no
    // state (fresh installs, logged-out users, and failed/missing backups).
    options.initializeStore();
  }

  if (!(window as any).cordova) {
    options.startApp(false);
    return;
  }

  const onDeviceReady = () => {
    document.removeEventListener('deviceready', onDeviceReady, false);
    options.onDeviceReady();
    if (!needsImport) {
      options.startApp(true);
      return;
    }
    void importNativeOriginStorage().then((outcome) => {
      options.initializeStore();
      options.startApp(true);
      options.onMigrationChecked(outcome);
    });
  };
  document.addEventListener('deviceready', onDeviceReady, false);
}



// WEBPACK FOOTER //
// ./src/appBootstrap.ts